document.addEventListener('click', function(e) {
    const title = e.target.closest('.accordion-title');

    if (!title) return;

    const item = title.closest('.accordion-item');
    const content = item.querySelector('.accordion-content');
    const icon = title.querySelector('.accordion-icon');

    item.classList.toggle('active');

    if (item.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.textContent = '-';
    } else {
        content.style.maxHeight = '0px';
        icon.textContent = '+';
    }
});
